/* eslint-disable react/prop-types */
import React from 'react';

import { useConfigValue } from '~/shared/utils/config';
import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import {
  isCioColorFacet,
  isImageSwatchFacet,
  isProductsV2ColorFacet,
} from '../../utils/filters';

import DesktopGridColorFilter from './DesktopGridColorFilter';
import DesktopGridColorWheelFilter from './DesktopGridColorWheelFilter';
import DesktopGridDefaultFilter from './DesktopGridDefaultFilter';
import DesktopGridFilterGroupDisclosure from './DesktopGridFilterGroupDisclosure';
import DesktopGridGroupedFilter from './DesktopGridGroupedFilter';
import DesktopGridImageFilter from './DesktopGridImageFilter';

const DesktopGridFilterRenderer = ({ facet, togglePanel, openPanels }) => {
  const { enabled: isColorWheelGridFilterEnabled } = useHasFeature(
    featureNames.COLOR_WHEEL_GRID_FILTER
  );
  const imageSwatchFilters = useConfigValue('public.imageSwatchFilters');

  if (facet?.sub_facets?.length > 0) {
    return (
      <DesktopGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <DesktopGridGroupedFilter {...facet} />
      </DesktopGridFilterGroupDisclosure>
    );
  }

  const shouldUseImageFilter = isImageSwatchFacet({
    facetName: facet?.name,
    imageSwatchFilters,
  });

  if (shouldUseImageFilter) {
    return (
      <DesktopGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <DesktopGridImageFilter {...facet} />
      </DesktopGridFilterGroupDisclosure>
    );
  }

  if (isCioColorFacet(facet?.name) || isProductsV2ColorFacet(facet?.name)) {
    return (
      <DesktopGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        {isColorWheelGridFilterEnabled ? (
          <DesktopGridColorWheelFilter {...facet} />
        ) : (
          <DesktopGridColorFilter {...facet} />
        )}
      </DesktopGridFilterGroupDisclosure>
    );
  }

  return (
    <DesktopGridFilterGroupDisclosure
      {...facet}
      togglePanel={togglePanel}
      openPanels={openPanels}
    >
      <DesktopGridDefaultFilter {...facet} />
    </DesktopGridFilterGroupDisclosure>
  );
};

export default DesktopGridFilterRenderer;
